"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var core_1 = require("@apollo/client/core");
var utils_1 = require("../model/utils");
var graphql_1 = require("../utils/graphql");
var wrapper_1 = require("../utils/wrapper");
var constant_1 = require("../utils/constant");
var fetchHumanResources = function (listParams) { return __awaiter(void 0, void 0, void 0, function () {
    var humanResponses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, wrapper_1.getClients()
                    .restClient.get(constant_1.FETCH_HUMAN_RESOURCES_URL + "?only-planning-active=" + Boolean(listParams === null || listParams === void 0 ? void 0 : listParams.onlyPlanningActive))
                    .then(function (_a) {
                    var data = _a.data;
                    return data;
                })
                    .catch(function (errResponse) {
                    var _a;
                    var error = (_a = errResponse === null || errResponse === void 0 ? void 0 : errResponse.response) === null || _a === void 0 ? void 0 : _a.data;
                    return error !== null && error !== void 0 ? error : errResponse;
                })];
            case 1:
                humanResponses = _a.sent();
                return [2 /*return*/, humanResponses];
        }
    });
}); };
var fetchPhysicalResources = function (listParams) { return __awaiter(void 0, void 0, void 0, function () {
    var physicalResponses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, wrapper_1.getClients()
                    .restClient.get(constant_1.FETCH_PHYSICAL_RESOURCES_URL + "?only-planning-active=" + Boolean(listParams === null || listParams === void 0 ? void 0 : listParams.onlyPlanningActive))
                    .then(function (_a) {
                    var data = _a.data;
                    return data;
                })
                    .catch(function (errResponse) {
                    var _a;
                    var error = (_a = errResponse === null || errResponse === void 0 ? void 0 : errResponse.response) === null || _a === void 0 ? void 0 : _a.data;
                    return error !== null && error !== void 0 ? error : errResponse;
                })];
            case 1:
                physicalResponses = _a.sent();
                return [2 /*return*/, physicalResponses];
        }
    });
}); };
var manageDaysAndOnlineOpening = function (dayId, params) {
    return wrapper_1.getClients()
        .restClient.patch(constant_1.PATCH_OPENED_DAYS_RESOURCE_URL + "/" + dayId, params)
        .catch(utils_1.errorHandler);
};
var getMarketplaceConnectedResourceIds = function (companyCode) { return __awaiter(void 0, void 0, void 0, function () {
    var getMarketplaceConnectedResourceIdsQuery, response, e_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                getMarketplaceConnectedResourceIdsQuery = core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query connectedResourceIds($companyCode: String) {\n            connectedResourceIds(companyCode: $companyCode)\n        }\n    "], ["\n        query connectedResourceIds($companyCode: String) {\n            connectedResourceIds(companyCode: $companyCode)\n        }\n    "])));
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.query({
                        query: getMarketplaceConnectedResourceIdsQuery,
                        variables: { companyCode: companyCode },
                    }))];
            case 2:
                response = (_c.sent());
                return [2 /*return*/, { data: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.connectedResourceIds }];
            case 3:
                e_1 = _c.sent();
                return [2 /*return*/, utils_1.mkpErrorHandler(graphql_1.gqlErrorFactory(e_1))];
            case 4: return [2 /*return*/];
        }
    });
}); };
var resource = {
    fetchHumanResources: fetchHumanResources,
    fetchPhysicalResources: fetchPhysicalResources,
    manageDaysAndOnlineOpening: manageDaysAndOnlineOpening,
    getMarketplaceConnectedResourceIds: getMarketplaceConnectedResourceIds,
};
var init = function () { return resource; };
exports.init = init;
var templateObject_1;
